const initialState = {
  isOpen: false,
  area: null,
  id: null,
  communityId: null,
  targetId: null,
  targetTitle: null,
  targetApp: 'SURVEY',
  targetType: null,
  language: 'fr',
  onCloseCallback: null
};

export const genericEmailingViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CLOSE_GENERIC_EMAILING_VIEWER': {
      return initialState;
    }
    case 'OPEN_GENERIC_EMAILING_VIEWER': {
      return { ...state, ...action.viewer };
    }
    default:
      return state;
  }
};
